import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const PICKLIST_ITEMS_MUTATION = gql`
  mutation addPicklistItems($items: [TBL_PICKLISTITEM_Input]) {
    addPicklistItems(items: $items)
  }
`;

export default function usePicklistItemsAdd() {
  const { mutate, loading, error } = useMutation(PICKLIST_ITEMS_MUTATION);

  async function addPicklistItems(items) {
    try {
      const { data } = await mutate({ items });
      return data;
    } catch (error) {
      console.error('Error adding options:', error);
      addAlert('Error adding options', 'high', 4);
    }
  }

  return {
    addPicklistItems,
    loading,
    error,
  };
}
